import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const deleteFavouriteStations = createReduxAsyncThunk<
  { favouriteStationCodes: FavouriteStation['stationCode'][] },
  FavouriteStation['stationCode'][]
>(
  `${STATIONS_STATE}/deleteFavouriteStations`,
  async (stationCodes) => {
    await stationsAPI.deleteFavouriteStations(stationCodes);
    return { favouriteStationCodes: stationCodes };
  }
);
